/* assets/ba-call-cart-drawer.js — fix first-add invisible + reliable section refresh */

const OPEN_TOGGLER_SEL = '[data-drawer-toggler]';
const ATC_SEL = '[data-add-to-cart]';

/* Vind de omliggende Shopify section + ID voor de cart drawer */
function getCartDrawerSectionEl() {
  // De section heeft in jouw schema class 'shopify-section-cart-drawer'
  // en ook altijd .shopify-section + id="shopify-section-<id>"
  let sec = document.querySelector('.shopify-section-cart-drawer.shopify-section');
  if (!sec) {
    // fallback: pak ouders van het <cart-drawer>-element
    const cd = document.querySelector('cart-drawer, [data-cart-drawer], #CartDrawer');
    if (cd) sec = cd.closest('.shopify-section');
  }
  return sec || null;
}

function getCartDrawerSectionId() {
  const sec = getCartDrawerSectionEl();
  if (!sec || !sec.id) return null;
  // id is bv. 'shopify-section-1234567890abcdef'; API wil alleen het stuk na prefix
  return sec.id.replace(/^shopify-section-/, '');
}

/* Drawer openen met meerdere fallbacks */
function openCartDrawerOnce() {
  if (openCartDrawerOnce.__opening) return;
  openCartDrawerOnce.__opening = true;

  try {
    const section = getCartDrawerSectionEl();
    section && section.classList.remove('close');

    if (globalThis.theme?.cartDrawer?.actionOpen) {
      globalThis.theme.cartDrawer.actionOpen();
      return;
    }

    const elCE = document.querySelector('cart-drawer');
    if (elCE) {
      if (typeof elCE.open === 'function') elCE.open();
      else {
        elCE.setAttribute('open', '');
        elCE.classList.add('is-open', 'active');
      }
      document.body.classList.add('overflow-hidden');
      return;
    }

    const el = document.querySelector('[data-cart-drawer]') || document.getElementById('CartDrawer');
    if (el) {
      el.setAttribute('open', '');
      el.classList.add('is-open', 'active');
      document.body.classList.add('overflow-hidden');
    }
  } catch (e) {
    console.warn('openCartDrawerOnce error', e);
  } finally {
    setTimeout(() => (openCartDrawerOnce.__opening = false), 400);
  }
}

/* Ververs de exacte cart-drawer section via de echte section-ID + bubble */
async function refreshCartSections() {
  const sectionId = getCartDrawerSectionId();
  if (!sectionId) return;

  const params = new URLSearchParams({
    sections: `${sectionId},cart-icon-bubble`,
  }).toString();
  const url = `${window.Shopify?.routes?.root || '/'}?${params}`;

  try {
    const res = await fetch(url, { method: 'GET', headers: { Accept: 'application/json' } });
    if (!res.ok) return;
    const data = await res.json();
    const parser = new DOMParser();

    // 1) Drawer section vervangen
    if (data[sectionId]) {
      const doc = parser.parseFromString(data[sectionId], 'text/html');
      const freshSection = doc.getElementById(`shopify-section-${sectionId}`);
      const currentSection = getCartDrawerSectionEl();
      if (freshSection && currentSection) {
        currentSection.replaceWith(freshSection);
      }
    }

    // 2) Bubble bijwerken (optioneel)
    if (data['cart-icon-bubble']) {
      const doc2 = parser.parseFromString(data['cart-icon-bubble'], 'text/html');
      const fresh = doc2.querySelector('.shopify-section');
      const dst = document.getElementById('cart-icon-bubble') || document.querySelector('[data-cart-bubble]');
      if (fresh && dst) dst.innerHTML = fresh.innerHTML;
    }
  } catch (e) {
    console.warn('refreshCartSections error', e);
  }
}

/* Intercept fetch + XHR voor /cart/add(.js) en open pas na verversing */
function installInterceptors() {
  // fetch
  if (!window.__atcFetchPatched && window.fetch) {
    window.__atcFetchPatched = true;
    const _fetch = window.fetch.bind(window);
    window.fetch = async (input, init) => {
      let url = '';
      try { url = typeof input === 'string' ? input : input?.url || ''; } catch {}
      const isAdd = typeof url === 'string' && /\/cart\/add(\.js)?(\?.*)?$/i.test(url);

      const res = await _fetch(input, init);
      if (isAdd && res?.ok) {
        // even wachten tot Shopify cart update klaar is
        setTimeout(async () => {
          await refreshCartSections();
          openCartDrawerOnce();
        }, 250);
      }
      return res;
    };
  }

  // XHR
  if (!window.__atcXHRPatched && window.XMLHttpRequest) {
    window.__atcXHRPatched = true;
    const _open = XMLHttpRequest.prototype.open;
    const _send = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function(method, url, ...rest) {
      this.__isATC = typeof url === 'string' && /\/cart\/add(\.js)?(\?.*)?$/i.test(url);
      return _open.call(this, method, url, ...rest);
    };
    XMLHttpRequest.prototype.send = function(body) {
      if (this.__isATC) {
        this.addEventListener('load', () => {
          if (this.status >= 200 && this.status < 300) {
            setTimeout(async () => {
              await refreshCartSections();
              openCartDrawerOnce();
            }, 250);
          }
        });
      }
      return _send.call(this, body);
    };
  }
}

/* Dubbelklik-demper op ATC knoppen */
function installDoubleClickGuard() {
  document.addEventListener(
    'click',
    (ev) => {
      const btn = ev.target.closest(ATC_SEL);
      if (!btn) return;
      if (btn.dataset._lock === '1') {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        ev.stopPropagation();
        return;
      }
      btn.dataset._lock = '1';
      setTimeout(() => (btn.dataset._lock = '0'), 1200);
    },
    true
  );
}

/* Toggler → open */
function bindToggler() {
  const toggler = document.querySelector(OPEN_TOGGLER_SEL);
  if (toggler) {
    toggler.addEventListener('click', (e) => {
      e.preventDefault();
      openCartDrawerOnce();
    });
  }
}

/* Init */
(function init() {
  bindToggler();
  installDoubleClickGuard();
  installInterceptors();
})();
